var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBody(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 112.2",
    style: {
      enableBackground: "new 0 0 70 112.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ED1C24;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_29_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "st0",
    d: "M54.9,47.8c-7.9-9-19.4-1.2-19.4-1.2S24,38.8,16,47.8c-9.7,11-16.9,30.7-5.7,37.2 s25.2,3.6,25.2,3.6s14,2.9,25.1-3.6S64.6,58.9,54.9,47.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6_",
    className: "st1",
    cx: 35,
    cy: 34.3,
    rx: 25.6,
    ry: 21.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_7_",
    className: "st2",
    x1: 35.5,
    y1: 13.7,
    x2: 35.5,
    y2: 2.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_9_",
    className: "st2",
    x1: 26.6,
    y1: 14.4,
    x2: 22.4,
    y2: 4.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_10_",
    className: "st2",
    x1: 19,
    y1: 18.1,
    x2: 11.2,
    y2: 10.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_11_",
    className: "st2",
    x1: 13.4,
    y1: 23.7,
    x2: 2.9,
    y2: 18.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_14_",
    className: "st2",
    x1: 43.4,
    y1: 14.4,
    x2: 47.6,
    y2: 4.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_13_",
    className: "st2",
    x1: 51,
    y1: 18.1,
    x2: 58.8,
    y2: 10.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_12_",
    className: "st2",
    x1: 56.6,
    y1: 23.7,
    x2: 67.1,
    y2: 18.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_2_",
    className: "st2",
    x1: 28.5,
    y1: 20.7,
    x2: 28.5,
    y2: 28.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_3_",
    className: "st2",
    x1: 41.5,
    y1: 20.7,
    x2: 41.5,
    y2: 28.7
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_4_",
    className: "st0",
    cx: 35,
    cy: 39.8,
    rx: 7.9,
    ry: 4.7
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody);
export default __webpack_public_path__ + "static/media/body.f28803e520c2a5d09a21632f4442d776.svg";
export { ForwardRef as ReactComponent };